export * from './lib/shared-routable-modal.module';
export * from './lib/shared-routable-modal.service';
